import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tokens.css";
import "./styles.css";
import "./styles/cinematic/foundation.css";
import "./styles/cinematic/proposal.css";
import "./styles/cinematic/shop.css";
import "./styles/cinematic/case.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
